import React from "react";
import "./version-badge-styles.scss";

const VersionBadge = () => {
  return <div className="version-badge-container d-inline-block">v1.0.4</div>;
};

export default VersionBadge;
